import { render, staticRenderFns } from "./transferPosting.vue?vue&type=template&id=d8f4ce72&scoped=true"
import script from "./transferPosting.vue?vue&type=script&lang=js"
export * from "./transferPosting.vue?vue&type=script&lang=js"
import style0 from "./transferPosting.vue?vue&type=style&index=0&id=d8f4ce72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f4ce72",
  null
  
)

export default component.exports